export enum InstallerAgreementsTypeEnum {
  RegulationAgreement = 'regulationAgreement',
}
